export enum DocumentEditingIntegrationType {
  Word = 'word',
}
